export const SPA_PACKAGE_FORM_NAME = 'SpaPackageForm';

export const spaPackageFormConfig = {
  form: SPA_PACKAGE_FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: false,
};
